import { render, staticRenderFns } from "./healthtrackingDetail.vue?vue&type=template&id=f1a3aa20&"
import script from "./healthtrackingDetail.vue?vue&type=script&lang=js&"
export * from "./healthtrackingDetail.vue?vue&type=script&lang=js&"
import style0 from "./healthtrackingDetail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports